import routerHelper from "helpers/routerHelper";
import documentService from "services/documentService";
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { NotificationHelper } from "helpers/notification-helper";
import { Redirect, Router } from "aurelia-router";

@autoinject
export class ServiceEquipmentDocumentAdd {
    public readonly: boolean = false;
    public dispatchId: string | null = null;
    public actions: any;

    public equipmentCode: any;
    public equipmentId: any;
    public isDirty: boolean = false;

    constructor(private readonly i18n: I18N, private readonly notificationHelper: NotificationHelper, private readonly router: Router) { }

    public async activate(params: any): Promise<void> {
        const paramsQueryString = routerHelper.getQuerystring(params.q);
        this.readonly = !(paramsQueryString && paramsQueryString.readonly === "false");
        this.dispatchId = params.dispatchId;

        this.equipmentCode = params.equipmentCode;
        this.equipmentId = paramsQueryString.equipmentId;

        this.actions = {
            save: documentService.saveEquipmentPicture.bind(this, params.serviceType, params.dispatchId, paramsQueryString.entityId, params.equipmentCode, paramsQueryString.equipmentId)
        };

    }

    public async canDeactivate(): Promise<any> {
        if (this.isDirty) {
            routerHelper.hideLoading(true);
            const msgWarning = this.i18n.tr("msg_UnsavedChangedWillBeLostConfirmation");
            const confirm = await this.notificationHelper.showDialogYesNo(msgWarning);
            if (!confirm) {
                return new Redirect((this.router.history as any).previousLocation, { trigger: false, replace: false });
            }
        }
        return true;
    }
}
